<div class="button-container">
  <!-- <h2>Preview Form</h2> -->
  <button class="button-close" mat-button [mat-dialog-close]="false">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
    </svg>
  </button>
</div>
<section class="dailog-container">
  <div class="d-flex justify-content-between">
    <button class="btn btn-primary" (click)="downloadAsPDF()">
      Download as PDF
    </button>
  </div>

  <div class="w-100 print" id="myDiv" #formContainer>
    <form>
      <div class="example-box" *ngFor="let item of obj; let i = index">
        <ng-container>
          <div class="client-details">
            <div class="d-flex justify-content-between">
              <!-- <h5 *ngIf="item.value == 'Your Details' || item.value == 'Customer Details  '">{{ item.value }}</h5> -->
            </div>
            <div class="form-group">
              <!-- <label
                *ngIf="
                  item[0].id != 'name' ||
                  item[0].id != 'addText' ||
                  item[0].id != 'shortText' ||
                  item[0].id != 'longText'
                "
                for="{{ item.id }}"
              >
                <span>{{ item[0].label }}</span>
              </label> -->
              <ng-container *ngIf="item[0].type == 'logo'">
                <div class="logo-container">
                  <img [src]="item[0]?.binaryData" alt="" />
                </div>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'formImage'">
                <div class="form-image-grid">
                  <img *ngFor="let img of item[0].formImages" [src]="img" class="static-image" />
                </div>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'text'">
                <ng-container *ngFor="let data of item">
                  <label [ngStyle]="data.isAddText ? { 'margin-bottom': '0' } : {}">{{ data?.label }}</label>
                  <input *ngIf="!data.isAddText && data.formId != 'longText'" [type]="data.type" [id]="data.formId + i"
                    class="form-control mb-2" [placeholder]="data.label" [(ngModel)]="data.value"
                    [name]="data.formId + i" [readonly]="isEdit === false" />
                  <textarea class="form-control" *ngIf="!data.isAddText && data.formId == 'longText'"
                    name="data.formId+i" id="data.formId+i" cols="40" rows="5" [(ngModel)]="data.value"
                    [placeholder]="data.label" [readonly]="isEdit === false"></textarea>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'radio'">
                <p>{{ item[0]?.label }}</p>
                <div class="d-flex gap-2 align-items-start" *ngFor="let option of item[0].value">
                  <input type="radio" class="mt-1" [id]="item[0].id + i" [name]="item[0].id + i" [value]="option"
                    (change)="toggleSelectionRadio(option, i)" [checked]="item[0].selectedOptions?.includes(option)"
                    [readonly]="isEdit === false" />
                  <label [for]="item[0].id + option">{{ option }}</label>
                </div>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'checkbox'">
                <p>{{ item[0]?.label }}</p>
                <div class="d-flex gap-2" *ngFor="let option of item[0].value; trackByFn: trackByIndex">
                  <input class="form-check-input" type="checkbox" [id]="option" [value]="option"
                    (change)="toggleSelection(option, i)" [checked]="item[0].selectedOptions?.includes(option)"
                    name="{{ item[0].id }}[]" [readonly]="isEdit === false" />
                  <label>{{ option }}</label>
                </div>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'select'">
                <p>{{ item[0]?.label }}</p>
                <select class="form-select form-control" [id]="item[0].id + i" [(ngModel)]="item[0].selectedOption"
                  [name]="item[0].id + i" [ngClass]="getSelectColorClass(item[0])" [disabled]="!isEdit">
                  <option *ngFor="let option of item[0].value; let optIndex = index" [ngValue]="optIndex">
                    {{ option.label }}
                  </option>
                </select>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'divider'">
                <hr class="divider-line" />
              </ng-container>
              <ng-container *ngIf="item[0].type === 'imageGallery'">
                <!-- <div class="logo-container" *ngIf="isEdit">

                                    <input #fileInput type="file" class="hidden-file-input" multiple
                                        name="{{ item[0].id }}"
                                        accept=".png,.jpg,.jpeg,.heic,.heif,image/heic,image/heif"
                                        (change)="uploadImageGalleryFile($event, i)" />

                                    <button type="button" class="add-image-btn" (click)="fileInput.click()">
                                        Add Image
                                    </button>
                                </div> -->
                <div class="image-gallery form-image-grid" *ngIf="item[0]?.value?.length">
                  <div class="image-wrapper" *ngFor="let img of item[0].value; let imgIndex = index">
                    <img [src]="img" alt="Uploaded image" class="static-image" />
                    <!-- <button type="button" class="delete-image-btn"
                                            (click)="removeImage(i, imgIndex)" *ngIf="isEdit" aria-label="Remove image">
                                            ✕
                                        </button> -->
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="item[0].type === 'signature'">
                <label class="signature-label">
                  {{ item[0].label || 'Signature' }}
                </label>
                <div class="signPad">
                  <img *ngIf="item[0]?.value" [src]="item[0]?.value" alt="" class="image-contain" />
                  <div class="signature-timestamp" *ngIf="item[0].signedAt && item[0]?.value">
                    Signed on: {{ item[0].signedAt | date:'dd MMM yyyy, hh:mm a' }}
                  </div>
                </div>

                <ng-container *ngIf="isEdit">
                  <div class="signPad">
                    <div class="signPad-board">
                      <ngx-signature-pad #signaturePad class="display-sign-pad" (signature)="getSignature($event)"
                        [containerStyle]="
                          'margin:0px auto;cursor:pointer;display:block;border-radius:9px;border: 1px solid #E8E8E8;height:240px'
                        " [(ngModel)]="signature" [height]="240" [lineStroke]="4"
                        [lineColor]="'red'"></ngx-signature-pad>
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-content-center">
                                        <button type="button" class="btn base-btn submit me-4 display-sign-pad"
                                            (click)="clear(signaturePad)">
                                            Reset
                                        </button>
                                        <button type="button" class="btn base-btn submit display-sign-pad"
                                            (click)="getFile(signaturePad, item[0], i)">
                                            Confirm Approval
                                        </button>
                                    </div> -->
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container class="page-break text-center" *ngIf="isEdit">
        <button class="btn btn-primary" type="submit">Save</button>
      </ng-container>
    </form>
  </div>
</section>
